// @ts-check
import DateTimePicker from 'Components/Common/DateTimePicker';
import ShrinkWrap from 'Components/Common/ShrinkWrap';
import Popup from "Components/Common/popup";
import 'Styles/commonComponents/settings/datePickerSetting.scss';
import IconsContainer from "Utils/IconsContainer";
import { observer } from 'mobx-react';
import React from "react";

const emptyStateObject = {};

/**
 * @param {{
 * id?: string,
 * title: string,
 * helperText?: string,
 * pickerOptions: import('Components/Common/DateTimePicker').DateTimePickerProps
 * buttonId?: string,
 * buttonValue?: string,
 * buttonDisabled?: boolean,
 * buttonClick?: () => void
 * }} props 
 * @returns {React.JSX.Element}
 */
const DateTimePickerSetting = (props) => {
    const [state, setState] = React.useState(emptyStateObject);

    const pickerOptions = props.pickerOptions ?? {};

    return (
        <div className='setting-container datetimepicker-setting'>

            <div className='setting-title datetimepicker-setting-title'>
                <ShrinkWrap>
                    {props.title}
                </ShrinkWrap>
                {props.helperText ?
                    <Popup
                        popupText={props.helperText}
                        className='fast-info-popup'>
                        {IconsContainer.Get('ci-info')}
                    </Popup>
                    : ''}
            </div>

            <div className='datetimepicker-setting-value-block'>
                <DateTimePicker {...pickerOptions} />
                {
                    props.buttonValue ?
                        <button
                            id={props.buttonId}
                            onClick={(e) => props.buttonClick?.()}
                            className={'datetimepicker-setting-value-button' + (props.buttonDisabled ? ' disabled' : '')}>
                            {props.buttonValue}
                        </button>
                        : ''
                }
            </div>

        </div>
    )
}

export default observer(DateTimePickerSetting);